@let isModalOpenedOnEdit = (data && data.idForEdit) || item;
@let isDialogStylesForced = dialogRef.ref.name === 'iframe' && !dialog.openDialogs.length;
@let isAnyDialogOpenInIframe = dialogRef.ref.name === 'iframe' && dialog.openDialogs.length;
<!-- Standalone item page in an iframe opened with ?hideHeader=true (e.g. OEE Tracker): the host shows its own header. -->
@let isEmbeddedInIframe = dialogRef.ref.name === 'iframe' && isHeaderHidden;

<div class="mat-mdc-dialog-container items-modal">
  @if (!isEmbeddedInIframe) {
    <div class="d-flex align-items-center pe-3">
      <h1 mat-dialog-title [class]="{ 'forced-dialog-title': isDialogStylesForced }">
        {{ data.title }}
      </h1>

      <app-due-date-chip
        class="mt-2"
        *ngIf="item && item?.dueDate"
        [doIgnoreDueDateCalculation]="item.currentWorkflowStep.statusCategory === 'done'"
        [dueDate]="{
          formatted: (item.dueDate ?? null | utcToUserFormatted: true) ?? '',
          original: item.dueDate ?? '',
        }"
        [strikeCount]="item.strikeCount"
      ></app-due-date-chip>
    </div>
  }

  <form
    trackFocusedOnce
    [formGroup]="addEditForm"
    (ngSubmit)="onFormDialogSubmit()"
    (firstFocus)="addEditForm.isFocusedOnce.next(true)"
    #form="ngForm"
  >
    @let iframeMargin = dialogRef.ref.name === 'iframe' && isIframe ? ' - 5px' : '';
    @let toolbarHeight = dialogRef.ref.name === 'iframe' && !isIframe ? ' - 50px' : '';
    @let dialogTitleHeight = isEmbeddedInIframe ? '' : ' - 68px';
    @let dialogActionsHeight = ' - 72px';
    <div
      mat-dialog-content
      [style]="{
        display: 'flex',
        height: 'calc(100vh' + iframeMargin + toolbarHeight + dialogTitleHeight + dialogActionsHeight + ')',
      }"
      [class]="{ 'dialog-body-unsets-for-iframe': isAnyDialogOpenInIframe, 'forced-dialog-body': isDialogStylesForced }"
    >
      <div class="row dialog-content-row pt-2">
        <div class="col-lg-9 col-md-12 left-inputs-container">
          <div [class]="{ 'mb-4': (cronToString$ | async) === null }">
            <div class="d-flex top-buttons-group">
              @if (hasBoardAiAgent()) {
                <app-ai-assist-button (assistClick)="openAiAssistDialog()" />
              }
              <button mat-stroked-button tabindex="-1" type="button" [matMenuTriggerFor]="menu">
                <mat-icon>add</mat-icon>
                {{ 'button.add' | translate }}
              </button>
              <button
                mat-stroked-button
                [hidden]="!item?.id || (isSubmitInProgress$ | async)"
                (click)="openEscalateModal()"
                type="button"
                tabindex="-1"
              >
                <mat-icon>arrow_upward</mat-icon>
                {{ 'page.items.escalation.escalate' | translate }}
              </button>
              <button
                mat-stroked-button
                [hidden]="!item?.id || !hasWorkInstructions || (isSubmitInProgress$ | async)"
                (click)="openChoreography()"
                type="button"
                tabindex="-1"
              >
                <mat-icon>view_timeline</mat-icon>
                {{ 'page.items.choreographyView' | translate }}
              </button>
              <button
                mat-stroked-button
                [hidden]="!item?.id || !hasIshikawaTemplate || (isSubmitInProgress$ | async)"
                (click)="openIshikawa()"
                type="button"
                tabindex="-1"
              >
                <mat-icon>set_meal</mat-icon>
                {{ 'page.items.ishikawaView' | translate }}
              </button>
              <button
                mat-stroked-button
                [hidden]="!item?.id || (isSubmitInProgress$ | async)"
                (click)="openWhiteboard()"
                type="button"
                tabindex="-1"
              >
                <mat-icon>draw</mat-icon>
                {{ 'page.items.whiteboard' | translate }}
              </button>
            </div>

            @if (cronToString$ | async) {
              <mat-hint class="text-grey pt-2 pb-075 d-block">{{ cronToString$ | async }}</mat-hint>
            }
          </div>
          <app-read-to-write-input
            class="d-block"
            [formControl]="addEditForm.controls.name"
            [label]="'field.title' | translate"
            [shouldBeStuckInWriteMode]="!isModalOpenedOnEdit"
            [isFormDataLoading]="(store.isDataForEditLoading$ | async) === true"
          ></app-read-to-write-input>
          <app-link-work-instruction
            [boardId]="selectedBoardId"
            [itemId]="item?.id"
            [itemKey]="item?.key"
            [dueDateForRecurrence]="item?.itemRecurrence ? item?.dueDate : null"
            [loadTrigger]="triggerWorkInstructionLoad"
            (hasWorkInstructionsChange)="hasWorkInstructions = $event"
          ></app-link-work-instruction>
          <app-text-editor
            class="d-block mb-4"
            [formControl]="addEditForm.controls.description"
            [isFormSubmitted]="form.submitted"
            [label]="'field.description' | translate"
            [noDataPlaceholder]="isModalOpenedOnEdit ? ('page.items.label.descriptionPlaceholder' | translate) : null"
            [shouldBeStuckInWriteMode]="!isModalOpenedOnEdit"
            [isFormDataLoading]="(store.isDataForEditLoading$ | async) === true"
          >
          </app-text-editor>

          <app-item-custom-fields
            *ngIf="addEditForm.controls.itemCategory.value?.length && !isDefaultFieldSetSelected"
            [fieldSetAssignments]="fieldSetAssignments"
            [customFieldsForm]="customFieldsForm"
            [addEditForm]="addEditForm"
            [isFormSubmitted]="form.submitted"
            [item]="item"
          ></app-item-custom-fields>
          <div
            *ngIf="
              store.boardItemConfigurationsLoading() !== ELoadStatus.initial &&
              store.boardItemConfigurationsLoading() !== ELoadStatus.loading
            "
          >
            <app-item-readonly-fields
              [fieldSetAssignments]="fieldSetAssignments"
              [isFormSubmitted]="form.submitted"
              [item]="item"
            ></app-item-readonly-fields>
          </div>
          <div class="mb-3">
            <app-link-item
              id="appLinkItem"
              [item]="item"
              [startDateForRecurringUpdate]="isRecurringUpdateAllowed() ? (item?.dueDate ?? null) : null"
              [loadStatus]="linkItemLoadStatusFromComponent"
              [initialLinkedItems]="data.linkedItems ?? []"
              (linkedItemsEvent)="handleLinkedItems($event)"
            ></app-link-item>
          </div>
          <div>
            <app-items-attachments
              [attachments]="initialAttachments"
              [itemId]="item?.id"
              [startDateForRecurringUpdate]="isRecurringUpdateAllowed() ? (item?.dueDate ?? null) : null"
              [boardId]="item?.boardId"
              [loadStatus]="attachmentLoadStatusFromComponent"
              (memoryStoredAttachments)="onMemoryStoredAttachmentsChange($event)"
              (hasOngoingProcessChange)="onAttachmentOngoingProcessChange($event)"
              [externalSelectedFiles]="selectedFileChangeEvent"
              (rulesChange)="onAttachmentRulesChange($event)"
              [capturedPhotoFile]="capturedPhotoFile"
              (deviceCameraAvailabilityChange)="onDeviceCameraAvailabilityChange($event)"
              (maxFilesCountExceededChange)="onMaxFilesCountExceededChange($event)"
            ></app-items-attachments>
          </div>
          <hr *ngIf="item" class="my-4" />
          <button
            *ngIf="item"
            class="mb-3"
            [style]="{ color: isShowComments ? '#448aff' : '' }"
            mat-button
            type="button"
            (click)="onClickCommentButton()"
          >
            {{ 'button.comments' | translate }}
          </button>
          <button
            *ngIf="item"
            class="mb-3 history-button"
            [style]="{ color: !isShowComments ? '#448aff' : '' }"
            mat-button
            type="button"
            (click)="onClickHistoryButton()"
          >
            {{ 'button.history' | translate }}
          </button>
          <app-item-comment *ngIf="item && isShowComments" [item]="item"></app-item-comment>
          <app-items-history *ngIf="item && !isShowComments" [item]="item"></app-items-history>
        </div>
        <div class="col-lg-3 col-md-12">
          <div class="row">
            <div class="12 mb-1">
              <mat-dropdown
                [formControl]="addEditForm.controls.boardId"
                [configurationInput]="{
                  hasDelayedDefaultValue: true,
                  singleSelection: true,
                  text: ('field.board' | translate),
                  repositionDropdownList: true,
                  hasMatError: !item?.escalatedBoardId,
                }"
                [options]="store.boardOptions()"
                (search)="searchBoards($event)"
                [isFormSubmitted]="form.submitted"
              ></mat-dropdown>
              <div class="escalated-board-info d-flex align-items-center" *ngIf="item?.escalatedBoardId">
                <mat-icon class="escalated-board-icon">arrow_upward</mat-icon>
                <span class="f-12 ms-1">{{ 'page.items.escalation.escalatedTo' | translate }}:</span>
                <div class="board d-flex ms-1">
                  <mat-icon>grid_on</mat-icon>
                  <span class="f-12 ms-1">{{ item?.escalatedBoard?.name }}</span>
                </div>
              </div>
            </div>
            <div class="12 mb-1">
              <mat-dropdown
                [formControl]="addEditForm.controls.itemType"
                [configurationInput]="{
                  hasDelayedDefaultValue: true,
                  isClientSide: true,
                  singleSelection: true,
                  text: ('field.itemType' | translate),
                  repositionDropdownList: true,
                }"
                [options]="itemTypeOptions"
                [isFormSubmitted]="form.submitted"
              ></mat-dropdown>
            </div>
            <div class="12 mb-1">
              <mat-dropdown
                [formControl]="addEditForm.controls.itemCategory"
                [configurationInput]="{
                  hasDelayedDefaultValue: true,
                  isClientSide: true,
                  singleSelection: true,
                  text: ('field.itemCategory' | translate),
                  repositionDropdownList: true,
                }"
                [options]="itemCategoryOptions()"
                [isFormSubmitted]="form.submitted"
              ></mat-dropdown>
            </div>
            <div class="12 mb-1 wf-status-row">
              <mat-dropdown
                class="wf-status-dropdown"
                [formControl]="addEditForm.controls.status"
                [configurationInput]="{
                  hasDelayedDefaultValue: true,
                  isClientSide: true,
                  singleSelection: true,
                  text: ('field.status' | translate),
                  repositionDropdownList: true,
                }"
                [options]="workflowStepOptions"
                [isFormSubmitted]="form.submitted"
              ></mat-dropdown>
              <button
                *ngIf="currentWorkflow"
                mat-icon-button
                type="button"
                class="wf-status-info"
                [matTooltip]="'button.viewWorkflow' | translate"
                (click)="openWorkflowDiagram()"
              >
                <mat-icon>account_tree</mat-icon>
              </button>
            </div>
            <div class="12 mb-1">
              <mat-dropdown
                [class.hide-error-placeholder]="isAssignToMeVisible()"
                [formControl]="addEditForm.controls.assignee"
                [configurationInput]="{
                  hasDelayedDefaultValue: true,
                  placeholder: ('page.items.label.unassigned' | translate),
                  singleSelection: true,
                  text: ('field.assignee' | translate),
                  repositionDropdownList: true,
                }"
                [options]="selectedBoardId ? store.boardMembers() : []"
                (search)="searchBoardMembers($event, $event === '' ? item?.assigneeId : undefined)"
                [isFormSubmitted]="form.submitted"
              ></mat-dropdown>
              @if (isAssignToMeVisible()) {
                <div class="assign-to-me">
                  <a class="link-button f-13" (click)="assignToCurrentUser()">{{ 'button.assignToMe' | translate }}</a>
                </div>
              }
            </div>
            <div class="12 mb-1">
              <mat-dropdown
                [formControl]="addEditForm.controls.priority"
                [configurationInput]="{
                  hasDelayedDefaultValue: true,
                  hasOptionIcons: true,
                  isClientSide: true,
                  singleSelection: true,
                  text: ('field.priority' | translate),
                  repositionDropdownList: true,
                }"
                [options]="priorityOptions"
                [isFormSubmitted]="form.submitted"
              ></mat-dropdown>
            </div>
            <div class="12 date-range-picker-container">
              <app-date-range-picker
                [ngClass]="{ 'strike-alert': item?.strikeCount || 0 > 3 }"
                [formControl]="addEditForm.controls.dueDate"
                [(dates)]="dueDate"
                [configurationInput]="{
                  drops: 'up',
                  label: ('field.dueDate' | translate),
                  opens: 'center',
                  showClearButton: true,
                  singleDatePicker: true,
                  showErrors: !!item?.itemRecurrenceId || (cronToString$ | async) === null,
                }"
                [isFormSubmitted]="form.submitted"
              ></app-date-range-picker>
            </div>

            @if (!item?.itemRecurrenceId && !!(cronToString$ | async)) {
              <mat-hint class="text-grey pt-1 pb-2 ps-4 mb-1 d-block f-12">{{ recurringItemDueDateHint }} </mat-hint>
            }
            <div class="12 date-range-picker-container pt-1">
              <app-date-range-picker
                [formControl]="addEditForm.controls.eventDate"
                [configurationInput]="{
                  drops: 'up',
                  label: ('field.eventDate' | translate),
                  opens: 'center',
                  showClearButton: true,
                  singleDatePicker: true,
                }"
                [isFormSubmitted]="form.submitted"
              ></app-date-range-picker>
            </div>
            <div class="12 mt-1">
              <mat-dropdown
                [formControl]="addEditForm.controls.shift"
                [configurationInput]="{
                  text: ('field.shift' | translate),
                  singleSelection: true,
                  repositionDropdownList: true,
                  isClientSide: true,
                  hasDelayedDefaultValue: true,
                }"
                [isFormSubmitted]="form.submitted"
                [options]="shiftOptions()"
                [actionIcon]="shiftFilterActionIcon()"
                [actionLabel]="shiftFilterActionLabelKey() | translate"
                (actionClick)="toggleLineShiftFilter()"
              ></mat-dropdown>
            </div>
            <div class="12 mt-1">
              <mat-dropdown
                [formControl]="addEditForm.controls.reporter"
                [configurationInput]="{
                  hasDelayedDefaultValue: true,
                  text: ('field.reporter' | translate),
                  singleSelection: true,
                  repositionDropdownList: true,
                }"
                [options]="selectedBoardId ? store.reporterMembers() : []"
                (search)="searchReporterMembers($event, $event === '' ? item?.reporterId : undefined)"
                [isFormSubmitted]="form.submitted"
              ></mat-dropdown>
            </div>
            <div class="mb-3">
              <p
                class="mt-0 mb-2 m f-12 mat-field-label-color"
                *ngIf="item?.createdAt"
                [matTooltip]="item?.createdAt ?? null | utcToUserFormatted: true"
              >
                {{ 'field.created' | translate: { date: item?.createdAt | relativeTime: userLanguage } }}
              </p>
              <p
                class="mt-0 f-12 mat-field-label-color"
                *ngIf="item?.changedAt"
                [matTooltip]="item?.changedAt ?? null | utcToUserFormatted: true"
              >
                {{ 'field.updated' | translate: { date: item?.changedAt | relativeTime: userLanguage } }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <mat-dialog-actions align="end" [class]="{ 'forced-dialog-footer': isDialogStylesForced }">
      @if (addEditForm && addEditForm.isThereUnsavedChanges()) {
        <button matButton="tonal" type="button" (click)="onDismiss()" [disabled]="isSubmitInProgress$ | async">
          {{ 'button.cancel' | translate }}
        </button>
        <button mat-flat-button type="submit" [disabled]="isSubmitInProgress$ | async">
          {{
            data.idForEdit
              ? ('button.saveChanges' | translate)
              : ('button.addContext' | translate: { context: 'field.item' | translate })
          }}
        </button>
      } @else if (isIframe || !dialogRef.ref.name) {
        <button matButton="tonal" [type]="'button'" (click)="onDismiss()">
          {{ 'button.close' | translate }}
        </button>
      }
    </mat-dialog-actions>
  </form>
</div>

<mat-menu #addAttachmentsMenu="matMenu">
  <button mat-menu-item (click)="fileInput.click()" type="button">
    <mat-icon>folder_open</mat-icon>
    <span>{{ 'button.uploadFiles' | translate }}</span>
    <input
      #fileInput
      multiple
      type="file"
      (change)="onFileChange($event, fileInput)"
      [accept]="attachmentRules.allowedUploadableFileMimes.join(',')"
      [disabled]="isMaxFilesCountExceeded"
      style="display: none"
    />
  </button>
  <button
    mat-menu-item
    (click)="openCamera()"
    [disabled]="!isDeviceCameraAvailable || isMaxFilesCountExceeded"
    type="button"
  >
    <mat-icon>photo_camera</mat-icon>
    <span>{{ 'button.takePhoto' | translate }}</span>
  </button>
</mat-menu>

<mat-menu #menu="matMenu">
  <button
    mat-menu-item
    type="button"
    [matMenuTriggerFor]="addAttachmentsMenu"
    [disabled]="isMaxFilesCountExceeded || hasAttachmentComponentOngoingProcess || (isSubmitInProgress$ | async)"
    [autofocus]="false"
    tabindex="-1"
  >
    <mat-icon>attach_file</mat-icon>
    {{ 'button.attachFile' | translate }}
  </button>
  <button
    mat-menu-item
    [disabled]="isSubmitInProgress$ | async"
    (click)="initializeLinkItem()"
    type="button"
    tabindex="-1"
  >
    <mat-icon>link</mat-icon>
    {{ 'button.link' | translate }}
  </button>
  @if ((store.isDataForEditLoading$ | async) === false) {
    <button
      mat-menu-item
      [disabled]="(isSubmitInProgress$ | async) || (!item?.itemRecurrenceId && item?.escalatedBoardId)"
      (click)="openRecurrenceEditModalIfEnabled()"
      type="button"
      tabindex="-1"
    >
      <mat-icon>repeat</mat-icon>
      {{ (item?.itemRecurrenceId ? 'button.showRecurrence' : 'button.manageRecurrence') | translate }}
    </button>
  }
  <button
    [disabled]="!item"
    mat-menu-item
    [matTooltip]="'workInstruction.tooltip' | translate"
    [matTooltipDisabled]="!!item"
    (click)="openWorkInstructionList()"
  >
    <mat-icon>menu_book</mat-icon>
    {{ 'field.workInstruction' | translate }}
  </button>
</mat-menu>
